import { useEffect } from 'react';
import { BaseTicketResponse } from '../../models';
import { useInboxLockStatus } from '../Inbox/useInboxLockStatus';
import { useTicketFlowModals } from '../../context';
import { useGetCalledTicketQuery } from '../../services/totem-sector.service';

const useRecoverTicket = () => {
  const trackId = (localStorage.getItem('TOTEM_SECTOR_ID') || '').replaceAll(
    '"',
    ''
  );

  const { data: recoveredTicket } = useGetCalledTicketQuery(trackId, {
    skip: !trackId,
  });

  const { ticketData, setTicketData, openCallModal, openAttendModal } =
    useTicketFlowModals();

  const openModalByStatus = (ticket: any) => {
    if (ticket?.status === 'CALLING') openCallModal();
    if (ticket?.status === 'ATTENDING') openAttendModal();
  };

  const { getLockStatus } = useInboxLockStatus();

  const prepareModalData = (ticket: any) => {
    const { isManuallyTakenByMe } = getLockStatus(ticket);

    const preparedData: BaseTicketResponse = {
      ...ticket,
      sectorId: ticket.sectorId,
      inboxId: ticket.inboxId,
      trackNumber: ticket.trackNumber,
      isAlreadyTaken: isManuallyTakenByMe,
    };
    setTicketData(preparedData);
  };

  useEffect(() => {
    if (!ticketData && recoveredTicket) {
      prepareModalData(recoveredTicket);
      openModalByStatus(recoveredTicket);
    }
  }, [recoveredTicket]);
};

export default useRecoverTicket;
